import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import If from 'components/if-statement';

export default function PrivateRoute({ children, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ location }) => {
        return (
          <If condition={true}>
            <If.Then>{children}</If.Then>
            <If.Else>
              <Redirect
                to={{
                  pathname: '/login',
                  state: { from: location },
                }}
              />
            </If.Else>
          </If>
        );
      }}
    />
  );
}
